import { cx } from "@emotion/css";
import axios from "axios";
import { useEffect, useState, MouseEvent as ReactMouseEvent, } from "react";

import React from "react";
import MaskDynamicComponent from "@/components/dataMasking/MaskDynamicComponent";
import { LogSeverity, dnbComLog, dnbGetCookie, isNotUndefined, sitePreferenceCookieName, trackDataMaskIconClickEvents, track_event } from "@/shared/FunctionCore";
import tippy from 'tippy.js';



const baseURLForEsgAPI = {
    development: "https://dev.dnb.com/",
    qa: "https://qa.dnb.com/",
    stage: "https://stage.dnb.com/",
    production: "https://www.dnb.com/",
};

const properties = {
    "esg_contactus_cta_link_text": "Contact us",
    "esg_contactus_cta_link_text_prefix": "Is this your business?",
    "esg_contactus_cta_link_text_suffix": " to understand how D&B calculated your company’s specific ESG Ranking, provide new or updated information to ensure your company’s ESG Ranking remains accurate and up to date, or dispute your current ranking.",
    "esg_industry_average_definition": "The industry average is the average of ESG Rankings for all companies in a specific SASB (Sustainability Accounting Standards Board) SICS sector and industry",
    "esg_industry_average_label": "ESG industry average:",
    "esg_industry_average_show": "true",
    "esg_ranking_cta_link_text": "What is D&B's ESG Ranking?",
    "esg_ranking_definition": "The D&B ESG Ranking is a 1-5 ranking distribution based on a company’s performance and risks related to environmental, social and governance factors, where 1 indicates the least ESG-related risks or best ESG performance compared to other companies, and 5 indicates the highest ESG-related risk or worst ESG performance compared to other companies",
    "esg_ranking_label": "ESG ranking:",
    "esg_ranking_show": "true",
    "esgMethodologyHrefUrl": "https://dnb.com/about-us/our-analytics/predictors-scores-ratings.html?id=5",
    "esgMethodologyText": "how ESG Rankings are calculated.",
    "esgPopoverTitle": "Leverage ESG insights to manage risk and increase supply chain resiliency",
    "staticProductSubscriptionLabel": "Annually",
    "staticProductSKUNumber": "M0006",
    "staticProductQty": "1",
    "staticProductPrice": "400.00",
    "staticESGInsightreportText": "Good news, an ESG Insights report is available.",
    "staticESGInsightreportButtonLabel": "See if an ESG Report is Available",
    "staticBuyEsgText": "Buy ESG Insights Report",
    "staticBuyEsgNoteText": "*You must have a U.S. or Canadian credit card to order an ESG report",
    "staticBuyEsgCompanySuffix": "ESG Insights Report",
    "esgPopoverLearnMoreURL": "https://www.dnb.com/en-us/products/dnb-esg-intelligence.html",
    "staticProductPriceca": "500.00",
    "showEsgReportCheck": true,
}

const EsgContainer = ({ esgData }): JSX.Element => {
    const {
        encryptedDuns,
        esgContactUsHrefUrl,
        esgIndustryAverage,
        esgRank,
        esgRankingHrefUrl,
        primaryName,
        magentoCartAddDomain,
        magentoCartAddEndpoint,
        magentoCartDisplayName,
        magentoCartServletPath,
        showEsgReportCheck,
        //below are not coming from overview API response
        locale,
        magentoCartApiKey, //AEM "57b89a4446e66fb0d833d581a34df837" 
        magentoCartToken,  // AEM Axi1u9YWXq7US5F
        magentoCartUniqueId, // AEM 5ltptoMXypVrYsqsxycTYVvZxqyCZ2Dh
    } = esgData;

    const {
        esg_contactus_cta_link_text,
        esg_contactus_cta_link_text_prefix,
        esg_contactus_cta_link_text_suffix,
        esg_industry_average_definition,
        esg_industry_average_label,
        esg_industry_average_show,
        esg_ranking_cta_link_text,
        esg_ranking_definition,
        esg_ranking_label,
        esg_ranking_show,
        esgMethodologyHrefUrl,
        esgMethodologyText,
        esgPopoverTitle,
        staticProductSubscriptionLabel,
        staticProductSKUNumber,
        staticProductQty,
        staticProductPrice,
        staticESGInsightreportText,
        staticESGInsightreportButtonLabel,
        staticBuyEsgText,
        staticBuyEsgNoteText,
        staticBuyEsgCompanySuffix,

        // showEsgReportCheck,
    } = properties;

    useEffect(() => {
        tippy('[data-tippy-content]', {
            theme: 'custom-themeee'
        });
    }, []);

    const [esgActionEnabled, setEsgActionEnabled] = useState(true);
    const [esgError, setEsgError] = useState(false);
    const [esgReportAvailable, setEsgReportAvailable] = useState(false);
    const [price, setPrice] = useState(`$${staticProductPrice}`);

    const sitePreferenceCookieValue = dnbGetCookie(sitePreferenceCookieName);

    const checkEsgSufficiency = (encryptedDunsParameter: string) => {
        setEsgActionEnabled(false);

        axios
            .get(`apps/dnb/thirdparty/esg`, {
                "params": {
                    "duns": encryptedDunsParameter
                }
            })
            .then((ax) => {
                const { data } = ax;

                const { isEsgInsightsAvailable } = data;

                if (isEsgInsightsAvailable === false) {
                    setEsgError(true);
                } else if (isEsgInsightsAvailable === true) {
                    setEsgReportAvailable(true);
                }
            }).catch((error) => {
                dnbComLog(LogSeverity.ERROR, error);
                setEsgError(true);
            });
    };

    const redirect = () => {
        track_event("ESG - Learn more Clicked");
        window.location.href = properties.esgPopoverLearnMoreURL;
    };

    useEffect(() => {
        if (isNotUndefined(sitePreferenceCookieValue) && sitePreferenceCookieValue.includes("-ca")) {
            setPrice(`C$${properties.staticProductPriceca}`);
        } else {
            setPrice(`$${properties.staticProductPrice}`);
        }
    }, [sitePreferenceCookieValue]);

    return (
        <>
            {(esg_ranking_show === "true" && esgRank !== "") || (esg_industry_average_show === "true" && esgIndustryAverage !== "") ? (
                <>
                    <div className={cx("row", "margin-between-rows", "company_snapshot_display")}>
                        <div className={cx("col-md-1", "company-profile-overview-icon-esg-rank")} />

                        <div className="col-md-11 paddingLeft">
                            {esg_ranking_show === "true" && esgRank !== "" ? (
                                <>
                                    <span className="company_data_point">
                                        <label>
                                            {esg_ranking_label}
                                        </label>

                                        <span data-tracking-name={esg_ranking_label}>
                                            <MaskDynamicComponent
                                                buttonAction={() => {
                                                    if (Boolean(showEsgReportCheck)) {
                                                        checkEsgSufficiency(encryptedDuns);
                                                    } else {
                                                        redirect();
                                                    }
                                                }}
                                                buttonLabel={Boolean(showEsgReportCheck) ? staticESGInsightreportButtonLabel : "Learn more"}
                                                text={esgPopoverTitle}
                                                type={'esg'}
                                            />
                                        </span>

                                        <span
                                            className="information-tool-tip"
                                            data-tippy-content={esg_ranking_definition}>
                                            <span className="information-icon" />
                                        </span>


                                    </span>

                                    <br />
                                </>
                            ) : (
                                <></>
                            )}

                            {esg_industry_average_show === "true" && esgIndustryAverage !== "" ? (
                                <span className="company_data_point">
                                    <label>
                                        {esg_industry_average_label}
                                    </label>

                                    <span data-tracking-name={esg_industry_average_label}>
                                        <MaskDynamicComponent
                                            buttonAction={() => Boolean(showEsgReportCheck) ? checkEsgSufficiency(encryptedDuns) : redirect()}
                                            buttonLabel={Boolean(showEsgReportCheck) ? staticESGInsightreportButtonLabel : "Learn more"}
                                            text={esgPopoverTitle}
                                            type={'esg'}
                                        />
                                    </span>

                                    <span
                                        className="information-tool-tip"
                                        data-tippy-content={esg_industry_average_definition}>
                                        <span className="information-icon" />
                                    </span>
                                </span>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>

                    {
                        Boolean(showEsgReportCheck)
                            ? <></>
                            : <div className={cx("row", "margin-between-rows", "company_snapshot_display")}>
                                <div className="col-md-1" />

                                <div className="col-md-11">
                                    <span className={cx("company_data_point", "company_profile_overview_underline_links")}>
                                        <a href={`${esgRankingHrefUrl}`}>
                                            {esg_ranking_cta_link_text}
                                        </a>
                                    </span>
                                </div>
                            </div>
                    }

                    {Boolean(showEsgReportCheck) ? <div className={cx("row", "margin-between-rows", "company_snapshot_display")}>
                        <div className="col-md-12">
                            Learn more about
                            {" "}

                            <a href={`${esgRankingHrefUrl}`}>
                                what an ESG Insights Report is
                            </a>

                            {" "}

                            and

                            {" "}

                            <a href={esgMethodologyHrefUrl}>
                                {esgMethodologyText}
                            </a>
                        </div>
                    </div> : <></>}

                    <div className={cx("row", "margin-between-rows", "company_snapshot_display")}>
                        <div className="col-md-12">
                            <span className="company_data_point">
                                {esg_contactus_cta_link_text_prefix}

                                {" "}

                                <a
                                    className="company_profile_overview_underline_links ext-icon"
                                    target="_blank"
                                    href={esgContactUsHrefUrl}>
                                    {esg_contactus_cta_link_text}
                                </a>

                                {" "}

                                {esg_contactus_cta_link_text_suffix}
                            </span>
                        </div>
                    </div>

                    {esgError ? <div className={cx("row", "margin-between-rows", "esg-error-block")}>
                        <div className="col-md-12">
                            <div className="esg-warning">
                                <div className="unverified-address-icon" />

                                <div>
                                    We&apos;re sorry, we&apos;re not able to provide an ESG Insights Report for
                                    {" "}

                                    <span>
                                        {primaryName}
                                    </span>

                                    {" "}
                                    at this time. If this is your company,

                                    {" "}

                                    <a
                                        className={cx("company_profile_overview_underline_links", "text-lowercase")}
                                        href={esgContactUsHrefUrl}>
                                        {esg_contactus_cta_link_text}
                                    </a>

                                    {" "}
                                    to provide information to enable a full ESG profile to be created for your business.
                                </div>
                            </div>
                        </div>
                    </div> : <></>}

                    {!esgError && !esgReportAvailable && Boolean(showEsgReportCheck) ? <div className={cx("row", "margin-between-rows", "company_snapshot_display")}>
                        <div className="col-md-12">
                            <span className={cx("company_data_point", "overview_cta")}>
                                <button
                                    className={cx("button-primary", "buy-esg-reports", "w-100")}
                                    disabled={!esgActionEnabled}
                                    onClick={() => checkEsgSufficiency(encryptedDuns)}
                                    type="button">
                                    {esgActionEnabled ? <span className="esg-button-text">
                                        {staticESGInsightreportButtonLabel}
                                    </span> : <></>
                                        //  <Loader />
                                    }
                                </button>
                            </span>
                        </div>
                    </div> : <></>}

                    {esgReportAvailable ? <div className={cx("row", "margin-between-rows", "company_snapshot_display")}>
                        <div className="col-md-12">
                            <div className="esg-report-container">
                                <div className={cx("headline-6", "spacing-mb-3")}>
                                    {staticESGInsightreportText}
                                </div>

                                <div className={cx("subtitle-2", "spacing-mb-5", "esg-report-price")}>
                                    <div>
                                        {primaryName}

                                        {" "}

                                        -
                                        {staticBuyEsgCompanySuffix}
                                    </div>

                                    <div>
                                        {price}
                                    </div>
                                </div>

                                <form
                                    action={`https://www.dnb.com${magentoCartServletPath}`}
                                    className={cx("form-inline", "magentoCart")}
                                    target="_self">
                                    <input
                                        name="newCartAddToCartUrl"
                                        type="hidden"
                                        value={magentoCartAddDomain + magentoCartAddEndpoint} />

                                    <input
                                        name="sku"
                                        type="hidden"
                                        value={staticProductSKUNumber} />

                                    <input
                                        name="displayName"
                                        type="hidden"
                                        value={magentoCartDisplayName} />

                                    <input
                                        name="price"
                                        type="hidden"
                                        value={price} />

                                    <input
                                        name="subscription_label"
                                        type="hidden"
                                        value={staticProductSubscriptionLabel} />

                                    <input
                                        name="qty"
                                        type="hidden"
                                        value={staticProductQty} />

                                    <input
                                        className="duns_number"
                                        name="dunsNumber"
                                        type="hidden"
                                        value={encryptedDuns} />

                                    <input
                                        className="company_name"
                                        name="companyName"
                                        type="hidden"
                                        value={primaryName} />

                                    <input
                                        name="_token"
                                        type="hidden"
                                        value={magentoCartToken} />

                                    <input
                                        name="unique_id"
                                        type="hidden"
                                        value={magentoCartUniqueId} />

                                    <input
                                        name="api_key"
                                        type="hidden"
                                        value={magentoCartApiKey} />

                                    <input
                                        name="locale"
                                        type="hidden"
                                        value={locale} />

                                    <input
                                        className={cx("button-primary", "buy-esg-reports", "w-100")}
                                        type="submit"
                                        value={staticBuyEsgText} />
                                </form>

                                <div className={cx("body", "spacing-mt-3")}>
                                    {staticBuyEsgNoteText}
                                </div>
                            </div>
                        </div>
                    </div> : <></>}
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default EsgContainer;
